<template>
    <div class="detail-section">
        <div class="dc-btn-block">
        <hr class="abv-hr">
        <div class="dc-btn detail"
            :class="{'dc-btn-active': strActiveTab === 'detail'}"
            @click="clickChangeTab('detail')">
            <div class="dc-inner-btn"><span :class="{'bd-right': strActiveTab === 'detail'}" >{{lbl.detail.detail}}</span></div>
        </div>
        <div class="dc-btn condition"
            :class="{'dc-btn-active': strActiveTab === 'condition'}"
            @click="clickChangeTab('condition')">
            <div class="dc-inner-btn"><span :class="{'bd-left': strActiveTab === 'condition'}">{{lbl.detail.condition}}</span></div>
        </div>
        <hr class="btm-hr">
    </div>
    <div class="dc-content">
        <div class="dc-content-item" v-show="strActiveTab === 'detail'" v-html="strDetail"></div>
        <div class="dc-content-item" v-show="strActiveTab === 'condition'" v-html="strCondition"></div>
    </div>
  </div>
</template>
<script>
import Util from '@/helper/Utility.js';

/**
 * @event clickChangeTab
 */
export default {
    name: "FreeGiftDetailAndCondition",
    props: {
        lbl: Object,
        campaign: Object,
        busEvent: Object
    },
    data: function() {
        return {
            strActiveTab: "detail", //detail, condition
            strDetail: "",
            strCondition: ""
        };
    },
    created: function() {
        //this.strDetail = "Now a must-have for makeup artists, Dior Lip Maximizer is the 1st Dior backstage lip plumper gloss for smooth, hydrated \nlips and an instant, long-lasting plump effect.";
        this.strDetail =  Util.newLineToBr(this.campaign.detail);
        this.strCondition = Util.newLineToBr(this.campaign.condition);
    },
    methods: {
        clickChangeTab: function(strTab) {
            this.strActiveTab = strTab;
        }
    }
};
</script>
<style lang="scss" scoped>
    .dc-content-item {
        word-break: break-word;
    }
</style>
